
import { useState, useEffect } from 'react';

import TaggingSidebar from '../../components/TaggingSidebar/TaggingSidebar';
import MainPlayerOverlays from '../../components/MainPlayerOverlays/MainPlayerOverlays';

import TaggingController from '../../controllers/Tagging';

import './WithTagging.css';

const calculateDimensions = taggingConfiguration => {
  return TaggingController.onResize( taggingConfiguration);
};

const Local_Globals = {
  taggingConfiguration: null,
};

export default function WithTagging( props) {
  const { taggingConfiguration } = props;
  Local_Globals.taggingConfiguration = taggingConfiguration;
  
  const [ dimensions, setDimensions ] = useState( calculateDimensions( taggingConfiguration));
  const [ player, setPlayer ] = useState( undefined);
  const [ onTime, setOnTime ] = useState( undefined);

  useEffect( () => {
    const handler = () => {
      if( Local_Globals.taggingConfiguration) setDimensions( calculateDimensions( Local_Globals.taggingConfiguration));
    };
    window.addEventListener( 'resize', handler);
    return () => window.removeEventListener( 'resize', handler);
  }, []);

  if( props.custom_3_playerConfiguration?.customProps ) {
    props.custom_3_playerConfiguration.customProps.width = dimensions.width;
    props.custom_3_playerConfiguration.customProps.height = dimensions.height;
  }

  const onPlayer = player => {
    setPlayer( player);
    if( props.onPlayer) props.onPlayer( player);
  };

  // console.log( 'layouts::WithTagging - props: ', props);    // DEBUG
  return (
    <div className='WithTagging'>
      <div style={ dimensions } className='PlayerContainer'>
        { props.PlayerComponent.render({ ...props, onPlayer, onTime }) }
        <MainPlayerOverlays { ...props } />
      </div>
      <TaggingSidebar player={player} setOnTime={setOnTime} taggingConfiguration={ taggingConfiguration}/>
    </div>
  );
}
